import { DocumentOwnerType, UserType, DocumentType } from '#types';
import rpcShared from '@rockpapercoin/rpc-shared';
import { FlattenedUser } from '../../types/user';

/**
 * checks if user owns the document
 * - if it's owned by the customer
 *    - is planner with permissions of document owner
 *    - or is admin of planner org with permissions
 * - if it's owned by an organization
 *    - is member of document organization
 */
export const userHasOwnerPermissionsForDoc = (
	user: FlattenedUser,
	document: {
		ownerType: DocumentOwnerType;
		type: DocumentType;
		customer?: {
			id: string;
			clientUser?: {
				plannerOrgHasDocumentsPermissions: boolean;
				assignedPlanner?: {
					id: string;
					organization?: { id: string } | null;
				} | null;
			} | null;
		} | null;
		orgUser?: { id: string } | null;
		organization?: { id: string } | null;
		sharedWithCustomer: boolean;
	}
) => {
	if ( !document || !user || !user.isLoggedIn ) {
		return false;
	}

	const orgUser =
		user.isLoggedIn && user.userType === UserType.OrgUser ? user : undefined;

	// if this is a "company file" and the user is from the owning organization, they have permissions
	if (
		orgUser?.organization?.id === document.organization?.id &&
		document.type === DocumentType.Internal
	) {
		return true;
	}

	// are you an APPA looking at a document a customer might look at?
	const userIsAPPA =
		document.customer && orgUser
			? rpcShared.contacts.isAssignedPlannerOrAdminOfCustomersPlannerOrg(
				{ customer: document.customer },
				orgUser
			  )
			: false;
	const userHasPermissionsAsAPPA =
		document.customer?.clientUser?.plannerOrgHasDocumentsPermissions &&
		userIsAPPA;
	if (
		userHasPermissionsAsAPPA &&
		document.ownerType === DocumentOwnerType.Customer
	) {
		return true;
	}

	// are you the customer?
	if (
		document.ownerType === DocumentOwnerType.Customer &&
		document.customer &&
		user.user.id === document.customer.id
	) {
		return true;
	}

	// are you from the owning organization?
	if (
		document.ownerType === DocumentOwnerType.Organization &&
		document.organization &&
		orgUser &&
		orgUser.organization?.id === document.organization.id
	) {
		return true;
	}
	return false;
};
